export default __webpack_public_path__ + "static/media/MM6C_JS6C.83ef8abb.jpg";